/**
 * 点单商品类型
 */
const TYPE_PRODUCT = 1 // 商品
const TYPE_PACKAGE = 2 // 套餐

const map = new Map([
  [TYPE_PRODUCT, { mean: '商品', type: 'success' }],
  [TYPE_PACKAGE, { mean: '套餐', type: 'primary' }]
])

export default {
  map,
  TYPE_PRODUCT,
  TYPE_PACKAGE
}
